import { CAMPAIGNS } from "../lib/constants/actions";
export const campaign = (state = {}, action) => {
    switch (action.type) {
        case CAMPAIGNS.GET_CAMPAIGNS_SUCCESS:
            return { ...state, list: action.payload }

        case CAMPAIGNS.GET_CAMPAIGNS_DATA_SUCCESS:
            return { ...state, details: action.payload }

        case CAMPAIGNS.CHANGE_STATUS_SUCCESS:
            return { ...state, statusUpdated: action.payload }

        case CAMPAIGNS.GET_CAMPAIGN_CHARGES_SUCCESS:
            return { ...state, charges: action.payload }

        case CAMPAIGNS.SAVE_CAMPAIGN_CHARGES_SUCCESS:
            return { ...state, chargesUpdated: action.payload }

        case CAMPAIGNS.GET_INTEREST_SUCCESS:
            return { ...state, interests: action.payload }

        case CAMPAIGNS.SAVE_INTEREST_SUCCESS:
            return { ...state, interestSaved: action.payload }


        case CAMPAIGNS.DELETE_INTEREST_SUCCESS:
            return { ...state, interestDeleted: action.payload }

        case CAMPAIGNS.GET_TRANSACTION_HISTORY_SUCCESS:
            return { ...state, transactionHistory: action.payload }



        default:
            return state;
    }
};




